import React, { Component } from "react";
import { connect } from "react-redux";
import WelcomeMessage from "./components/Steps/WelcomeMessage";
import CurrentStep from "./components/CurrentStep";
import CompletedSteps from "./components/CompletedSteps";
import PractitionerDrawer from "./components/Steps/DrawerContent/PractitionerDrawer";
import LocationDrawer from "./components/Steps/DrawerContent/LocationDrawer";
import ScheduleDrawer from "./components/Steps/DrawerContent/ScheduleDrawer";
import ContinueButton from "./components/ContinueButton";
import { bookingPortalSelector } from "./selectors";
import { initialLoad, goToPage } from "./actions";

class BookingPortal extends Component {
  componentDidMount = () => {
    if (!this.props.loaded) this.props.initialLoad();
  };

  handleContinueButtonClick = () => {
    this.props.goToPage("contactform");
  };

  renderWelcomeMessage = () => {
    const { welcomeMessage, loading } = this.props;

    if (loading || !welcomeMessage) return null;

    return <WelcomeMessage message={welcomeMessage} />;
  };

  renderStepHistory = () => {
    const { completedSteps, loading } = this.props;
    if (loading) return null;
    if (completedSteps.length === 0) return null;
    return <CompletedSteps steps={completedSteps} />;
  };

  renderCurrentStep = () => {
    const { current, loading } = this.props;
    if (loading) return null;
    return <CurrentStep key={current} current={current} />;
  };
  renderContinueButton = () => {
    if (!this.props.completed) return null;
    return <ContinueButton onClick={this.handleContinueButtonClick} />;
  };

  render() {
    return (
      <div className="booking-portal-container">
        {this.renderWelcomeMessage()}
        {this.renderStepHistory()}
        {this.renderCurrentStep()}
        <PractitionerDrawer />

        <LocationDrawer />

        <ScheduleDrawer />
        {this.renderContinueButton()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return bookingPortalSelector(state);
};

export default connect(mapStateToProps, { initialLoad, goToPage })(
  BookingPortal
);



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/index.js